import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { screens as HomePageScreens } from '../../modules/HomePage';
import { screens as UserScreens } from '../../modules/Users';
import appRoutes from '../../app-routes';

const { HelpPage } = HomePageScreens;
const { SetObsoletePassword } = UserScreens;

const PasswordlessRoutes = () => {
  return (
    <Switch>
      <Route
        path={appRoutes.PASSWORD_OBSOLETE_SET}
        component={SetObsoletePassword}
      />
      <Route path={appRoutes.SUPPORT} component={HelpPage} />
      <Route component={SetObsoletePassword} />
    </Switch>
  );
};

export default PasswordlessRoutes;
